import { Iterator } from "../../src/utils/Iterator";
import SoundController from "../../src/utils/SoundController";
import betModel from "../model/BetModel";
import BetModel from "../model/BetModel";
import UIController from "../../src/ui/UIController";
import stateMachine from "../states/StateMachine";
import AutoplayModel from "../model/AutoplayModel";
import { UIStates } from "../../src/ui/UIStates";
import { UIUpdateEvent } from "../ui/UIUpdateEvents";
import GameModel from "../model/GameModel";
import SoundVars from "../const/SoundVars";
import CommManager from "../controllers/CommManager";
import RequestRegister from "../server/requests/RequestRegister";
import { TweenMax } from "gsap";
import App from "../App";
import SpinModel from "../model/SpinModel";

// Bet Commands

export function IterateCoinsCommand(iterator: Iterator) {
  betModel.cycleCoinSize(iterator);
  UpdateBetCommand();
}

export function IterateBetCommand(iterator: Iterator) {
  betModel.cycleBetMultiplier(iterator);
  UpdateBetCommand();
}

export function IterateLinesCommand(iterator: Iterator) {
  betModel.cycleNumLines(iterator);
}

export function IterateStakeCommand(iterator: Iterator) {
  IterateBetCommand(iterator);
  IterateCoinsCommand(iterator);
}

export function IterateTotalBetCommand(dir?: number) {
  BetModel.cycleTotalBet(dir);
  UpdateBetCommand();
}

export function SetMaxBetCommand() {
  betModel.setStake(betModel.getMaxBet(), betModel.getMaxCoinIndex());
  UpdateBetCommand();
}

export function SetBetCommand(coinSizeIndex: number) {
  console.log("[GameCommands] Set Bet Command: " + coinSizeIndex);
  betModel.setStake(null, coinSizeIndex);
  SpinModel.update(betModel.getCurrentBetStateData());
  UpdateBetCommand();
}

export function SaveSettingsCommand() {
  CommManager.send(
    RequestRegister.get("saveSettingsRequest"),
    (data) => {
      console.log("[GameCommands] Saved Settings", data);
    },
    this
  );
}

// Game Commands

export function SkipCommand() {
  stateMachine.skip();
}

export function SpinCommand(stopSound?) {
  if(stopSound != true) {
    SoundController.playSound(SoundVars.BUTTON_CLICK, false);
  }
  stateMachine.skip();
}

export function ToggleSpaceToSpinCommand() {
  GameModel.toggleSpaceToSpin();
  UpdateSettingsCommand();
}

export function ToggleTuboSpinCommand() {
  GameModel.toggleTurboSpin();
  UpdateSettingsCommand();
}

// Autoplay Commands

export function StartAutoplayCommand() {
  AutoplayModel.startAutoSpin();
  SpinCommand(true);
}

export function DecrimentAutoplay() {
  AutoplayModel.decrementAutoSpinNum();
  UpdateAutoplayCommand();
}

export function StopAutoplayCommand() {
  AutoplayModel.setAutoSpin(0);
  UIController.setState(UIStates.AUTO_STOP);
}

export function ClearAutoplayLimitsCommand() {
  AutoplayModel.clearLimits();
}

export function SetAutoplaySingleWinLimitCommand(limit: number) {
  AutoplayModel.setWinLimit(limit);
}

export function SetAutoplayLossLimitCommand(limit: number) {
  AutoplayModel.setLossLimit(limit);
}

export function SetAutoplayTotalWinLimitCommand(limit: number) {
  AutoplayModel.setTotalWinLimit(limit);
}

export function ToggleAutoplayStopOnFeatureCommand() {
  AutoplayModel.toggleStopOnFeatureWin();
  UpdateAutoplayCommand();
}

export function ToggleAutoplayStopOnWinCommand() {
  AutoplayModel.toggleStopOnAnyWin();
  UpdateAutoplayCommand();
}

export function ToggleAutoplayStopOnBigWinCommand() {
  AutoplayModel.toggleStopOnBigWin();
  UpdateAutoplayCommand();
}

// Sound Commands

export function ToggleSoundFXCommand(enabled?: boolean) {
  SoundController.toggleEffects(enabled);
  UpdateSettingsCommand();
}

export function ToggleMusicCommand(enabled?: boolean) {
  SoundController.toggleMusic(enabled);
  UpdateSettingsCommand();
}

export function ToggleMasterSoundCommand(enabled?: boolean) {
  SoundController.toggleMasterSound(enabled);
  UpdateSettingsCommand();
}

export function SetMasterVolumeCommand(volume: number) {
  SoundController.masterVolume = volume;
}

// UI update commands

export function UpdateWinCommand(props?: any) {
  UIController.updateFields(UIUpdateEvent.Win, props);
}

export function UpdateBangupWinCommand() {
  UIController.updateFields(UIUpdateEvent.Bangup_win);
}

export function UpdateTempWinCommand() {
  UIController.updateFields(UIUpdateEvent.TempWin);
}

export function UpdateBalanceCommand() {
  UIController.updateFields(UIUpdateEvent.Balance);
}

export function UpdateSettingsCommand() {
  UIController.updateFields(UIUpdateEvent.Settings);
}

export function UpdateAutoplayCommand() {
  UIController.updateFields(UIUpdateEvent.Autoplay);
}

export function UpdateBetCommand() {
  UIController.updateFields(UIUpdateEvent.Bet);
}

export function UpdateFreeSpinsCommand(value: any) {
  UIController.updateFields(UIUpdateEvent.FreeSpins, value);
}

export function ClearWinFieldCommand() {
  UIController.updateFields(UIUpdateEvent.ClearWin);
}

export function ClearFreeSpinsCommand() {
  UIController.updateFields(UIUpdateEvent.FreeSpins);
}

export function UpdateUICommand() {
  UpdateWinCommand();
  UpdateBalanceCommand();
  UpdateSettingsCommand();
  UpdateAutoplayCommand();
  UpdateBetCommand();
}

// Info Bar Commands

export function UpdateInfoBarCommand() {
  UIController.updateFields(UIUpdateEvent.InfoBar);


  // This command needs to re-trigger itself

  TweenMax.killDelayedCallsTo(UpdateInfoBarCommand);

  TweenMax.delayedCall(
    App.config.infoBar.changeTime || 3,
    UpdateInfoBarCommand
  );
}

// View Commands

export function CloseSettingsCommand() {
  if (!UIController.isComponentHidden("settings")) {
    UIController.toggleComponent("settings");
  }
}

export function ToggleAutoplaySettingsCommand() {
  UIController.toggleComponent("settings", "autoplay");
}

export function ToggleBetSettingsCommand() {
  UIController.toggleComponent("settings", "bet");
}

export function ToggleSettingsCommand() {
  UIController.toggleComponent("settings", "settings");
}

export function TogglePaytableCommand() {
  UIController.toggleComponent("settings", "paytable");
}

export function ToggleBetPopupCommand() {
  UIController.toggleComponent("betPopup");
}

export function ToggleAutoplayPopupCommand() {
  UIController.toggleComponent("autoplayPopup");
}

export function ShowErrorPopup(callback) {
  UIController.toggleComponent("errorPopup", callback);
}

export function GoHome() {
  if (GameModel.homeUrl) {
    if (GameModel.homeUrl === "close") {
      window.close();
    } else {
      window.open(GameModel.homeUrl, "_self");
      //     window.location.href = GameModel.urlParams.homeurl;
    }
  } else {
    window.history.back();
  }
}

export function OpenRCHistory() {
    if (GameModel.urlParams.rchistoryurl) {   
      window.location.href = GameModel.urlParams.rchistoryurl;
    }
}
